var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingCombShortRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 80,
    viewBox: "0 0 116 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    width: 80,
    height: 106,
    rx: 4,
    transform: "rotate(90 116 0)",
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.666,
    cy: 40.1123,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5113 51.999H74.9113V38.199C74.9113 34.799 74.9113 27.399 64.6613 27.399C60.8613 27.399 57.1113 28.549 54.4613 31.249L57.6113 34.399C59.2113 32.899 61.5113 31.899 64.0113 31.899C67.2113 31.899 69.5113 33.449 69.5113 36.399V37.049H68.0113C62.0113 37.049 52.9113 37.599 52.9113 45.399C52.9113 50.149 57.2113 52.599 61.6613 52.599C64.8613 52.599 67.6613 51.399 69.3613 48.699H69.5113V51.999ZM69.1613 42.599C69.1613 45.949 67.2113 48.099 63.1113 48.099C61.1613 48.099 58.9113 47.149 58.9113 44.949C58.9113 41.499 64.6113 41.249 67.9113 41.249H69.1613V42.599Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 7.99902,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 17 7.99902)",
    fill: "#52B3A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 27.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 17 27.999)",
    fill: "#52B3A7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 47.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 17 47.999)",
    fill: "#52B3A7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 67.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 17 67.999)",
    fill: "#52B3A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 70.999L2.99999 70.999C1.34314 70.999 -8.46565e-06 69.6559 -8.3208e-06 67.999L-3.3377e-06 10.999C-3.19286e-06 9.34217 1.34314 7.99902 3 7.99902L5.00001 7.99902L5 70.999Z",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingCombShortRight);
export default __webpack_public_path__ + "static/media/jobconfig-binding-comb-short-right.9f7c48e4919124bef50612178d50e0c3.svg";
export { ForwardRef as ReactComponent };